<template>
  <div>
    <b-container>
      <div>
        <slot />
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "blank-layout"
};
</script>

<style scoped></style>
